import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const dropzoneBaseSx = {
  minHeight: '172px',
  width: '100%',
  border: `1.5px dashed ${foundations.colors.gray300}`,
  background: foundations.colors.gray50,
  borderRadius: '3px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '24px',
  textAlign: 'center',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
};

export const styles = createTypedSxStyles({
  resultContainer: {
    display: 'flex',
    gap: '16px',
    flexWrap: 'wrap',
  },
  imagePreview: {
    borderRadius: '3px',
    flexShrink: 0,
    maxWidth: '100%',
    maxHeight: '300px',
    '& img': {
      width: 'auto',
      height: 'auto',
      maxWidth: '100%',
      maxHeight: '100%',
    },
  },
  imageInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flexShrink: 0,
    paddingBottom: '16px',
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  errorIcon: {
    color: foundations.colors.yellow700,
    fontSize: '24px',
  },
  errorText: {
    color: foundations.colors.yellow700,
    display: 'flex',
    alignItems: 'center',
  },
  uploadIcon: {
    fill: foundations.colors.gray700,
    fontSize: '24px',
  },
});
